import(/* webpackMode: "eager", webpackExports: ["GlobalProviders"] */ "/vercel/path0/apps/aura/src/app/[locale]/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@mui+material@5.16.7_@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1__@emotion+style_5fmx4zgukdrr7c4hrz6h7clcfi/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@mui+material@5.16.7_@emotion+react@11.13.3_@types+react@18.3.12_react@18.3.1__@emotion+style_5fmx4zgukdrr7c4hrz6h7clcfi/node_modules/@mui/material/Typography/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.1.11_@babel+core@7.28.5_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react-dom@_vmxaonv2jhhnn5k527lpsigije/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Raleway\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["CollapseClient"] */ "/vercel/path0/packages/features/me/src/components/information-banner/collapse.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nClientProvider"] */ "/vercel/path0/packages/shared/i18n/src/provider/i18n-client.provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/datadog/rum-listener.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/nps-form-stepper/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/nps-gauge/nps-gauge.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/nps-survey/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/nps-textarea/nps-textarea.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/relationship-banner/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/tracking/src/nps/components/transactional-modal/index.tsx");
